import { css } from "@compiled/react";
import { FormattedMessage, defineMessages } from "react-intl";
import { PricingPlan } from "src/contentful";
import { UserLocale } from "src/utils/useGeoCurrency";

import { media } from "@atlaskit/primitives";

import { CalculatorSection } from "@/components/wpl/pricing/src/calculator";
import { ProductFeatureTeam24 } from "@/components/wpl/pricing/src/price-finder/team-twenty-four/product-feature-team24";

const estimateContainer = css({
    padding: "20px 20px 20px 0",

    [media.above.sm]: {
        h2: {
            fontSize: "1rem",
            lineHeight: "1.5rem"
        }
    }
});

const dataCenterCalculatorContainerRedesign = css({
    display: "flex",
    width: "100%",
    flexWrap: "wrap"
});

const calculatorContainerRedesign = css({
    width: "15.75rem",
    marginBlockEnd: "40px",

    [media.above.sm]: {
        width: "19.685rem"
    }
});

const productFeatureContainerRedesign = css({
    marginBlockEnd: "40px",
    p: {
        marginBlockStart: "0px"
    },

    [media.above.sm]: {
        marginInlineStart: "30px"
    }
});

const messages = defineMessages({
    dataCenter: {
        id: "ConfluencePricingPageTemplate.dataCenterCalculator-dataCenter",
        defaultMessage: "Data Center"
    },
    perYear: {
        id: "ConfluencePricingPageTemplate.dataCenterCalculator-perYear",
        defaultMessage: "per year"
    },
    tryItFree: {
        id: "ConfluencePricingPageTemplate.dataCenterCalculator-tryItFree",
        defaultMessage: "Try it Free"
    },
    buyNow: {
        id: "ConfluencePricingPageTemplate.dataCenterCalculator-buyNow",
        defaultMessage: "Buy now"
    },
    units: {
        id: "ConfluencePricingPageTemplate.dataCenterCalculator-users",
        defaultMessage: "users"
    }
});

export interface DataCenterCalculatorSectionProps {
    serverSidePricing?: PricingPlan[];
    countryCode?: UserLocale;
}

export const DataCenterCalculator = ({
    serverSidePricing,
    countryCode
}: DataCenterCalculatorSectionProps) => {
    return (
        <div>
            <div css={estimateContainer}>
                <h2>
                    <FormattedMessage
                        id="ConfluencePricingPageTemplate.estimateDataCenterCost"
                        defaultMessage="Estimate your Atlassian Data Center cost"
                    />
                </h2>
            </div>

            <div css={dataCenterCalculatorContainerRedesign}>
                <div css={calculatorContainerRedesign}>
                    <CalculatorSection
                        serverSidePricing={serverSidePricing}
                        countryCode={countryCode}
                        productKey="pricingplan.confluence-data-center"
                        messages={messages}
                        buttonWithDataEvent={{
                            url: "/software/confluence/download/data-center",
                            dataEventProps: {
                                "data-product-key": "confluence",
                                "data-label": "Try it free",
                                "data-event-component": "linkButton",
                                "data-track-event":
                                    "ConfluencePricingPageTemplate.DataCenterCalculator.tryItFree",
                                "data-event-container":
                                    "priceBlockDropdownLocalized",
                                "data-event": "clicked"
                            }
                        }}
                        linkWithDataEvent={{
                            url: "/purchase/product/confluence.data-center",
                            dataEventProps: {
                                "data-product-key": "confluence",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-label": "Buy now",
                                "data-event-container": "priceBlock",
                                "data-track-event":
                                    "ConfluencePricingPageTemplate.DataCenterCalculator.buyNow"
                            }
                        }}
                    />
                </div>
                <div css={productFeatureContainerRedesign}>
                    <ProductFeatureTeam24 />
                </div>
            </div>
        </div>
    );
};
